import { render, staticRenderFns } from "./IdleTimeoutOverlay.vue?vue&type=template&id=642bf53e&scoped=true"
import script from "./IdleTimeoutOverlay.vue?vue&type=script&lang=js"
export * from "./IdleTimeoutOverlay.vue?vue&type=script&lang=js"
import style0 from "./IdleTimeoutOverlay.vue?vue&type=style&index=0&id=642bf53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bf53e",
  null
  
)

export default component.exports